export default [
  {
    path: '/app/defines/service-categories',
    name: 'ServiceCategories',
    component: () => import('@/views/Defines/Service_categories/Index.vue'),
    meta: {
      pageTitle: 'Hizmet Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'SERVICE_CATEGORIES_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/defines/service-categories/add',
    name: 'ServiceCategoriesAdd',
    component: () => import('@/views/Defines/Service_categories/Add.vue'),
    meta: {
      pageTitle: 'Hizmet Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/service-categories',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'SERVICE_CATEGORIES_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/defines/service-categories/edit/:id',
    name: 'ServiceCategoriesEdit',
    component: () => import('@/views/Defines/Service_categories/Edit.vue'),
    meta: {
      pageTitle: 'Hizmet Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/service-categories',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'SERVICE_CATEGORIES_EDIT',
      action: 'read',
    },
  },
]
